module.exports = __webpack_public_path__ + "static/media/Nian Nian You Yu Asia.4e5317bf.png";